import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Slide from '@mui/material/Slide';

// Styles
import styles from './index.module.sass';

export default function ToastItemProduct({ item }) {
  const [open, setOpen] = useState(true);

  const { t } = useTranslation('products');

  useEffect(() => {
    setTimeout(function () {
      setOpen(false);
    }, 1500);
  }, []);
  return (
    <Slide direction='left' in={open} mountOnEnter unmountOnExit>
      <div className={styles.item}>
        <div className={styles.itemContainer}>
          <img
            src={`https://webimages.terramarbrands.com.mx/images-usa/shopping-cart/cart-products/${item}.jpg`}
            className={styles.image}
            alt={item}
          />
          <div className={styles.itemActions}>
            <div className={styles.actionText}>{t('ProductAddedToCart')}</div>
            <div className={styles.itemData}>
              <div className={styles.itemText}>
                <span className={styles.title}>{t('keyPlaceholder')}: </span>
                <span className={styles.text}>{item}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
}
